<mat-card class="mtb">
    <mat-card-content>
        <div class="row  animate__animated animate__fadeIn">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
                <h1 class="titulo-simpli">cambia tu contraseña</h1>
                <small class="subtitulo-simpli">Cambia tu contraseña de inicio de sesión</small>
            </div>
            
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
                <form [formGroup]="valForm">
                    <div class="row">

                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
                            <mat-form-field appearance="fill">
                                <mat-label>Contraseña actual</mat-label>
                                <input formControlName="password" matInput [type]="hide ? 'password' : 'text'" required>
                                <mat-hint>Introduce tu contraseña actual para verificar si esta correcta</mat-hint>
                                <button type="button" mat-icon-button matSuffix (click)="hide = !hide"
                                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                                    <mat-icon style="color: gray;">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                                </button>
                            </mat-form-field>

                            <button mat-stroked-button class="secondary-button mt-20" color="primary" type="button"
                                (click)="verify_password()">Verificar
                            </button>
                        </div>



                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
                            <mat-form-field appearance="fill" [ngClass]="{'readonly-field': disabledButton}">
                                <mat-label>Contraseña nueva</mat-label>
                                <input formControlName="new_password" matInput [type]="hide ? 'password' : 'text'"
                                    required>
                                <mat-hint>Introduce tu contraseña nueva</mat-hint>

                                <button type="button" mat-icon-button matSuffix (click)="hide = !hide"
                                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                                    <mat-icon style="color: gray;">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                                </button>

                                <mat-error
                                    *ngIf="valForm.controls['new_password'].hasError('required') && (valForm.controls['new_password'].dirty || valForm.controls['new_password'].touched)">
                                    Este campo es <strong>requerido</strong>
                                </mat-error>

                                <mat-error *ngIf="valForm.controls['new_password'].hasError('minlength')">
                                    La contraseña debe ser de al menos 6 carácteres.
                                </mat-error>
                            </mat-form-field>
                        </div>


                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
                            <mat-form-field appearance="fill" [ngClass]="{'readonly-field': disabledButton}">
                                <mat-label>Repita la contraseña nueva</mat-label>
                                <input formControlName="re_new_password" matInput [type]="hide ? 'password' : 'text'"
                                    required>
                                <mat-hint>Repita su contraseña nueva</mat-hint>

                                <button type="button" mat-icon-button matSuffix (click)="hide = !hide"
                                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                                    <mat-icon style="color: gray;">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                                </button>

                                <mat-error
                                    *ngIf="valForm.controls['re_new_password'].hasError('required') && (valForm.controls['re_new_password'].dirty || valForm.controls['re_new_password'].touched)">
                                    Este campo es <strong>requerido</strong>
                                </mat-error>

                                <mat-error *ngIf="valForm.get('re_new_password')!.hasError('equalTo')">
                                    Las contraseñas no coinciden
                                </mat-error>
                            </mat-form-field>



                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
                            <button [disabled]="disabledButton" mat-stroked-button class="primary-button mt-10"
                                color="primary" type="button" (click)="submitForm($event, valForm.value)">Cambiar
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </mat-card-content>
</mat-card>